import { createAction } from 'redux-actions';

export const getCurrentAnswer = createAction('GET_CURRENT_ANSWER');
export const getActiveDetail = createAction('GET_ACTIVE_DETAIL');
export const saveAnswers = createAction('SAVE_ANSWERS');
export const saveDocuments = createAction('SAVE_DOCUMENTS');
export const saveAttachments = createAction('SAVE_ATTACHMENTS');
export const removeAnswers = createAction('REMOVE_ANSWERS');
export const removeDocuments = createAction('REMOVE_DOCUMENTS');
export const removeAttachments = createAction('REMOVE_ATTACHMENTS');
export const setCollapseClient = createAction('SET_COLLAPSE_CLIENT');
export const setCurrentNotificationReview = createAction('SET_CURRENT_NOTIFICATION_REVIEW');
export const setCurrentNotificationReviewId = createAction('SET_CURRENT_NOTIFICATION_REVIEW_ID');
export const goBackClientNotify = createAction('GO_BACK_CLIENT_NOTIFY');
export const getAdvisors = createAction('GET_ADVISORS');
export const setLastNotifyId = createAction('SET_LAST_NOTIFY_ID');
export const saveContactAnswers = createAction('SAVE_CONTACT_ANSWERS');
